import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@env/environment";
import { Observable } from "rxjs";
import { TokenService } from "./token.service";

@Injectable()
export class TransactionService {
  constructor(private http: HttpClient, private tokenService: TokenService) {}

  doPayment(paymentFlowBody: any): Observable<any> {
    const token = this.tokenService.getToken();
    const reqHeaders = {
      Authorization: `JWT ${token}`,
    };
    return this.http.post<any>(
      `${environment.baseUrlApi}/transactions/cash`,
      paymentFlowBody,
      { headers: reqHeaders }
    );
  }

  deleteTransaction(transactionUuid: string) {
    const token = this.tokenService.getToken();
    const reqHeaders = {
      Authorization: `JWT ${token}`,
    };
    return this.http.delete<any>(`${environment.baseUrlApi}/transactions/${transactionUuid}`, {
      headers: reqHeaders,
    });
  }

  updateTransaction(transactionUuid: string, payload: any) {
    const token = this.tokenService.getToken();
    const reqHeaders = { Authorization: `JWT ${token}` };
    return this.http.put<any>(
      `${environment.baseUrlApi}/transactions/${transactionUuid}`,
      payload,
      { headers: reqHeaders }
    );
  }

}
